import React from 'react';
import { CnLayoutAside as UICnLayoutAside } from '@/components/cn-layout';
const CnLayoutAside = (props) => {
    const { children } = props || {};
    return <UICnLayoutAside>{children}</UICnLayoutAside>;
};
CnLayoutAside.displayName = 'CnLayoutAside';
CnLayoutAside.typeMark = 'Aside';
export default CnLayoutAside;
export { CnLayoutAside };
